import * as React from 'react';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-apollo';
import { Button, Form } from 'react-bootstrap';
import { GET_FARMS, GET_GROWERS2 } from '../../../../../../queries';
import { GetFarms, GetGrowers } from '../../../../../../__generated__/types';

import { useStore } from "../../../../providers/AppProvider";
import { Farm, Grower } from '../../../../types/types';
import { getYears } from '../../../../utils/misc';
import { useFieldStore } from '../../providers/FieldProvider';

type FieldFilterProps = {
    onCancel: () => void
}

const FieldFilter = ({onCancel}: FieldFilterProps) => {
    const { state: { crops } } = useStore();
    const { filters, updateFilter } = useFieldStore();

    const { data: growerData, refetch: refetchGrower } = useQuery<GetGrowers>(GET_GROWERS2);
    const { data: farmData, refetch: refetchFarms } = useQuery<GetFarms>(GET_FARMS);

    useEffect(() => {
        refetchGrower();
        refetchFarms();
    }, []);

    const [growers, setGrowers] = useState<Grower[]>([]);
    const [farms, setFarms] = useState<Farm[]>([]);
    const [years, setYears] = useState<number[]>([]);
    const [initialLoad, setInitialLoad] = useState<boolean>(true);
    const [initialLoad2, setInitialLoad2] = useState<boolean>(true);

    const [localFilter, setLocalFilter] = useState({
            ...filters,
            //has_dsc: true,
        });


    useEffect(() => {
        setGrowers(growerData ? growerData.landscan_growers.map(g => { 
            return {
                id: g.grower_id,
                name: g.name,
                description: g.description
            } as Grower
        }) : []);
    }, [growerData]);


    useEffect(() => {
        setFarms(farmData ? farmData.landscan_farms.map(f => { 
            return {
                id: f.farm_id,
                grower_id: f.grower_id,
                name: f.name,
                description: f.description
            } as Farm
        }) : []);
    }, [farmData]);


    useEffect(() => {
        setLocalFilter({...filters});
        /*console.log("Z041924 filters,initialLoad", filters, initialLoad)
        if (initialLoad){
            console.log("Z041924 ---> ", filters, initialLoad)
            setInitialLoad(false);
            setLocalFilter({
                ...filters,
                has_dsc: true,
            });
        }
        console.log("081723 filters", filters)*/
    }, [filters])

    useEffect(() => {
        console.log("Z041924 localFilter", localFilter)
        /*if (initialLoad2 && localFilter.has_dsc){
            console.log("Z041924 ---> ", filters, initialLoad)
            setInitialLoad2(false);
            updateFilter(localFilter);
        }*/
    }, [localFilter])

    const onChange = (e: any) => {
        console.log("041624 e", e)
        setLocalFilter({
            ...localFilter, 
            [e.target.name]: [e.target.value]
        });
    }

    const onChangeBoolean = (e: any) => {
        console.log("I041624 e", e)
        console.log("I041624 e.target.value", e.target.value)
        console.log("I041624 e.target.checked",e.target.checked)
        setLocalFilter({
            ...localFilter, 
            [e.target.name]: e.target.checked
        });
    }


    const clearFilter = (key:string) => {
        setLocalFilter({
            ...localFilter, 
            [key]: []
        });
    }


    const applyFilter = () => {
        updateFilter(localFilter);
    }


    const cancelFilter = () => {
        onCancel();
    }

    console.log("081723 localFilter", localFilter)
    return (
        <div className="bg-white shadow-sm border-bottom border-top px-3 py-2">
            <h5 className="text-base">Filtering</h5>
            <div className="d-flex mt-2">
                <Form.Check
                    type="checkbox"
                    label="Has DSC"
                    name="has_dsc"
                    checked={localFilter.has_dsc}
                    onChange={(e:any) => onChangeBoolean(e)}
                />
            </div>
            <div className="d-flex mt-2">
                <Form.Check
                    type="checkbox"
                    label="Has DVS"
                    name="has_dvs"
                    checked={localFilter.has_dvs}
                    onChange={(e:any) => onChangeBoolean(e)}
                />
            </div>
            <div className="d-flex mt-2">
                <Form.Control
                    as="select"
                    size="sm"
                    name="grower_id"
                    value={localFilter && localFilter.grower_id.length ? localFilter.grower_id[0].toString() : ''}
                    onChange={(e:any) => onChange(e)}
                >
                    <option value="" label="filter by grower" className="" disabled />
                    {growers.map(option => {
                        return <option key={option.id} value={option.id}>{option.name}</option>
                    })}
                </Form.Control>
                { localFilter.grower_id.length > 0 &&                 
                    <Button variant="secondary" size="sm" className="ml-2" onClick={(e:any) => clearFilter("grower_id")}>X</Button>
                }
            </div>
           
            <div className="d-flex mt-2">
                <Form.Control
                    as="select"
                    size="sm"
                    name="farm_id"
                    value={localFilter && localFilter.farm_id.length ? localFilter.farm_id[0].toString() : ''}
                    onChange={(e:any) => onChange(e)}
                >
                    <option value="" disabled>filter by ranch</option>
                    {farms.map(option => {
                        return <option key={option.id} value={option.id}>{option.name}</option>
                    })}
                </Form.Control>
                { localFilter.farm_id.length > 0 &&                 
                    <Button variant="secondary" size="sm" className="ml-2" onClick={(e:any) => clearFilter("farm_id")}>X</Button>
                }
            </div>

            <div className="d-flex mt-2">
                <Form.Control
                    as="select"
                    size="sm"
                    name="crop_id"
                    value={localFilter && localFilter.crop_id.length ? localFilter.crop_id[0].toString() : ''}
                    onChange={(e:any) => onChange(e)}
                >
                    <option key={-1} value="" disabled>filter by crop</option>
                    {crops.map(c => {
                        return <option key={c.id} value={c.id}>{c.name}</option>
                    })}
                </Form.Control>
                { localFilter.crop_id.length > 0 &&                 
                    <Button variant="secondary" size="sm" className="ml-2" onClick={(e:any) => clearFilter("crop_id")}>X</Button>
                }
            </div>

            <div className="d-flex mt-2">
                <Form.Control
                    as="select"
                    size="sm"
                    name="year_planted"
                    value={localFilter && localFilter.year_planted.length ? localFilter.year_planted[0].toString() : ''}
                    onChange={(e:any) => onChange(e)}
                >
                    <option key={-1} value="" disabled>filter by year planted</option>
                    {getYears(2000).map(year => {
                        return <option key={year} value={year}>{year}</option>
                    })}
                </Form.Control>
                { localFilter.year_planted.length > 0 &&                 
                    <Button variant="secondary" size="sm" className="ml-2" onClick={(e:any) => clearFilter("year_planted")}>X</Button>
                }
            </div>

            <Button variant="primary" className="mt-2" size="sm" onClick={applyFilter}>
                Apply
            </Button>
            <Button variant="secondary" className="mt-2 ml-2" size="sm" onClick={cancelFilter}>
                Close
            </Button>
        </div>
    );
}

export default FieldFilter;